import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import styles from "./assignApprentice.module.scss";
import { useLazyApprenticeLookupQuery } from "store/services/utility";
import { cloneDeep, debounce } from "lodash";
import { successMessageToast, userFullName } from "helpers/common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { CloseIcon } from "Assets/icons";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { STATUS_OPTIONS } from "config/constants";
import { useAddTeamMemberMutation } from "store/services/team";
const AddTeamMemberPop = ({ setShow, show }) => {

  const hideHandler = () => setShow(false);
  const [usersList, setUsersList] = useState([]);
  const [selectedUsers, setselectedUsers] = useState([]);

  const [getUsersListQuery, { isLoading: getUserLoading, isFetching: getUserFetching }] = useLazyApprenticeLookupQuery();
  const [addTeamMember, { isLoading: addTeamMemberLoading }] = useAddTeamMemberMutation();

  const handleSelect = (item) => {

    const list = cloneDeep(selectedUsers);
    const index = list?.findIndex(x => x.id == item?.id);

    if (index > -1) delete list[index];
    else list.push(item);

    setselectedUsers(list?.filter(Boolean));
  };

  const handleStatusChange = (item) => {
    const list = cloneDeep(usersList);
    const index = list?.findIndex(x => x.id == item?.id);

    list[index] = { ...list[index], status: list[index]?.status == "active" ? "archived" : "active" };
    setUsersList(list);
  };

  const getUsers = async (search) => {
    try {

      const result = await getUsersListQuery(search);
      if (result?.error) return console.error("Error searching apprentice", result.error);

      setUsersList(result?.data?.map(i => ({ ...i, status: "active" })));
    } catch (err) { console.error("Error searching apprentice", err); }
  };

  const handleSearch = useCallback(debounce((event) => {
    getUsers(event.target?.value);
  }, 500), []);

  useEffect(() => {
    getUsers();
  }, []);

  const handleSubmit = async () => {
    try {

      if (!selectedUsers?.length) return;
      setShow(false);
      const result = await addTeamMember({ team_members: selectedUsers?.map(({ id = "", status = "active" }) => ({ id, status })) });
      if (result?.error) return;

      setselectedUsers([]);
      successMessageToast(result?.data?.message);
    } catch (err) { console.log("Error adding team member") }
  };

  return (
    <>
      {addTeamMemberLoading && <LoadingOverlay />}
      <Modal
        show={show}
        className={`${styles.addNewMember} transparentModal`}
        onHide={hideHandler}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
        scrollable
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <Button
            onClick={hideHandler}
            className="border-0 p-0 position-absolute"
            variant="transparent"
            style={{ right: 10, top: 0 }}
          >
            <CloseIcon />
          </Button>

          <div className="">
            <div className="d-flex flex-column py-2 justify-content-start">
              <h6 className="m-0 fw-bold themeBlue ">Add Member</h6>
              <p
                className="m-0 text-muted themeBlue"
                style={{
                  fontWeight: "400",
                  fontSize: "small",
                  lineHeight: "16px",
                  alignItems: "left",
                }}
              >

              </p>
            </div>

            <div className="d-flex  flex-column py-2 ">
              <div className="w-100 py-1">
                <Form>
                  <div className="iconWithText position-relative">
                    <span
                      className="icn position-absolute"
                      style={{ right: 10 }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.2621 15.5742L9.27139 10.8848C8.81306 11.2632 8.28598 11.5594 7.69014 11.7733C7.09431 11.9872 6.47793 12.0941 5.841 12.0941C4.27426 12.0941 2.9483 11.5517 1.86312 10.4668C0.777942 9.38192 0.235352 8.05626 0.235352 6.48983C0.235352 4.92356 0.777789 3.59744 1.86266 2.5115C2.94754 1.42571 4.27319 0.882812 5.83962 0.882812C7.4059 0.882812 8.73201 1.4254 9.81796 2.51058C10.9037 3.59576 11.4466 4.92172 11.4466 6.48846C11.4466 7.14311 11.3368 7.76835 11.1171 8.36419C10.8973 8.96002 10.604 9.47824 10.2373 9.91886L15.228 14.608L14.2621 15.5742ZM5.841 10.7193C7.02212 10.7193 8.02251 10.3094 8.84216 9.48962C9.66197 8.66997 10.0719 7.66958 10.0719 6.48846C10.0719 5.30733 9.66197 4.30694 8.84216 3.48729C8.02251 2.66749 7.02212 2.25758 5.841 2.25758C4.65987 2.25758 3.65948 2.66749 2.83983 3.48729C2.02003 4.30694 1.61012 5.30733 1.61012 6.48846C1.61012 7.66958 2.02003 8.66997 2.83983 9.48962C3.65948 10.3094 4.65987 10.7193 5.841 10.7193Z"
                          fill="#1C1B1F"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control"
                      style={{ height: 40, padding: "4 30px", width: "100%" }}
                      onChange={handleSearch}
                    />
                  </div>
                </Form>
              </div>
              <div style={{ maxHeight: "200px", overflowY: "scroll" }}
                className="d-flex flex-column justify-content-start px-2">
                {
                  getUserLoading || getUserFetching ? <LoadingIndicator /> : usersList?.map((item, index) => {
                    return (
                      <div key={index} className="d-flex my-1 justify-content-between  w-100">
                        <div style={{ width: "60%" }} className="d-flex gap-2 align-items-center ">
                          <p className="m-0 text-sm fw-sbold ">{userFullName(item)}</p>
                        </div>
                        <div>
                          <Form.Select
                            value={item?.status}
                            onChange={() => handleStatusChange(item)}
                          >
                            {
                              STATUS_OPTIONS.map((item) => {
                                return <option key={item.value} value={item.value} label={item.label} />
                              })
                            }
                          </Form.Select>
                        </div>
                        <div className="py-2">
                          <input
                            type="checkbox"
                            style={{ height: 20, width: 20 }}
                            className="form-check"
                            onChange={(e) => handleSelect(item)}
                            checked={selectedUsers.find(x => x.id == item?.id)}
                          />
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>

          <div
            className={`${styles.btnWrpper} btnWrpper d-flex justify-content-center align-items-center gap-10 pt-3 mt-3`}
            style={{ borderTop: "1px solid #41a2a84d" }}
          >
            <Button
              className="d-flex align-items-center w-100 px-10 justify-content-center commonBtn"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AddTeamMemberPop;
